export default {
    email_template_edit: 'Edit Template',
    template_add: 'Add New Template',
    email_template_add: 'Add Email Template',
    email_insert_tag: 'Insert Tag',
    email_tag_warning: 'Replacement tags can only replace users registered in the system. Non-system users cannot be replaced.',
    email_language: 'Type',
    email_title: 'Title',
    email_enter_template_name: 'Please enter the template name',
    email_sender_name: 'Sender Name',
    email_reply_email: 'Reply Email',
    email_subject: 'Subject',
    email_template_content: 'Template Content',
    email_status: 'Whether to enable',
    email_detail_title: 'Email Content',
    email_recipient: 'Email',
    email_sender: 'Sender',
    email_send_time: 'Send Time',
    email_provider_status: 'Carrier Send Status',
    email_response_id: 'Send Return Value',
    email_content_label: 'Email Content:',
    sms_detail_title: 'SMS Content',
    sms_recipient: 'Phone Number',
    sms_content_label: 'SMS Content',
    confirm_info_correct: 'Please confirm whether the following information is correct',
    email_list_total: 'The list to be sent contains a total of',
    items: ' items',
    recipient_type: 'Chinese/Foreign Guests',
    email_template: 'Email Template',
    sys_template: 'System Template',
    email_target_list: 'Email List',
    btn_back: 'Back',
    btn_send_immediately: 'Send Immediately',
    preview_title: 'Preview',
    email_balance_available: 'Balance',
    email_price: 'Email Price',
    email_sendable_count: 'Available Email Sends',
    btn_recharge_online: 'Online Recharge',
    email_recipient: 'Recipient',
    email_please_select_recipient: 'Please select the recipient',
    recipient_type_china: 'Chinese Guests',
    recipient_type_abroad: 'Foreign Guests',
    email_custom_address: 'Custom Email Address',
    email_batch_input_hint: 'For batch input, each number should be on a separate line.',
    email_batch_limit_tip: 'Note: The maximum number of entries is 10,000.',
    please_select_language: 'Please select the language',
    template_language_zh: 'Chinese Template',
    template_language_en: 'English Template',
    please_select_template: 'Please select the template',
    please_enter_sender_name: 'Please enter the sender name',
    please_enter_reply_email: 'Please enter the reply email',
    please_enter_theme: 'Please enter the theme',
    email_content: 'Email Content',
    please_enter_email_content: 'Please enter the email content',
    btn_submit_preview: 'Submit for Preview',
    email_recipient_count: 'Number of Recipients',
    sms_preview_title: 'SMS Preview',
    recipient_type: 'Chinese/Foreign Guests',
    sms_target_list: 'Phone Number List',
    sms_template: 'SMS Template',
    sms_content_example: 'SMS Content Example',
    sms_channel: 'Channel',
    sms_sign: 'SMS Signature',
    send_success: 'Send Successful',
    sms_price: 'SMS Price',
    sms_sendable_count: 'SMS Remaining',
    sms_list: 'SMS List',
    sms_template: 'SMS Template',
    please_select_sms_template: 'Please select the SMS template',
    sms_custom_template: 'Custom SMS',
    please_enter_sms_content: 'Please enter the SMS content',
    sms_max_length_limit: 'The maximum length of a single SMS cannot exceed 500 characters.',
    sms_total_count: 'Total SMS Count',
    sms_billing_rule: 'Per 70 characters (less than 70 characters are counted as 70 characters)',
    sms_tips_with_tags: 'Note: If the SMS content contains tags, the character count of the SMS content is based on the character count after tag replacement!',
    sms_billing_details:
        'SMS billing rule: One charge for up to 70 characters. For more than 70 characters, one charge for every 67 characters. The maximum supported length of an SMS is 500 characters. Counted by characters, 1 English letter, 1 number, 1 punctuation mark, 1 space, and 1 Chinese character all count as 1 character. Long SMSs are charged in multiples of 67 characters.',
    please_enter_sms_list: 'Please fill in the SMS list',
    sms_template_edit: 'Edit SMS Template',
    sms_template_add: 'Add SMS Template',
    sms_enter_title: 'Please enter the SMS title',
    sms_enable: 'Enable',
    sms_disable: 'Disable',
    email_params_config_zh: 'Chinese Parameter Configuration',
    email_params_config_en: 'English Parameter Configuration',
    sender_name_placeholder: 'Please enter the sender name',
    receive_email_placeholder: 'Please enter the send/receive email',
    email_format_error: 'Incorrect email format',
    merchant_contact_label: 'Merchant Contact Information (Can be used for unified tag calls in email templates)',
    merchant_contact_placeholder: 'Please enter the merchant contact information',
    submit_button_text: 'Submit Now',
    setting_success_message: 'Settings saved successfully',
    email_search_email: 'Email',
    email_search_status: 'Send Status',
    email_status_success: 'Send Successful',
    email_status_failure: 'Send Failed',
    email_search_button: 'Search',
    email_total_count: 'Total: {value} items',
    email_count: 'Quantity (items)',
    email_operation: 'Operation',
    email_preview: 'Click to View',
    download_template: 'Download Template',
    upload_excel_tip: 'Warm reminder: The uploaded Excel data must contain the {value} column and place {value} in the first column.',
    click_or_drag_upload: 'Click or drag to upload a file',
    confirm_send_content: 'Confirm to send?',
    please_upload_file: 'Please upload a file with the {type} extension',
    email_template_chinese: 'Chinese Email Template',
    email_template_english: 'English Email Template',
    table_id: 'ID',
    template_type: 'Template Type',
    sms_search_phone: 'Phone Number',
    sms_search_phone_placeholder: 'Please enter the phone number',
    sms_table_phone: 'Phone',
    click_insert_tag: 'Click to Insert Tag',
    send_sms: 'Send SMS',
    characters: 'characters',
    help_doc: 'Help Document',
    send_email: 'Send Email',
    email_please_enter_email_content: 'Please enter the email content'
};
